import * as React from "react";
import { cn } from "../../lib/utils";
import { APP_DOWNLOAD_BANNER_STYLES } from "./constants";
import type { AppDownloadBannerProps } from "./types";

export const AppDownloadBanner = React.forwardRef<
  HTMLElement,
  AppDownloadBannerProps
>(
  (
    {
      className,
      description,
      appStoreUrl,
      playStoreUrl,
      appStoreImageUrl,
      playStoreImageUrl,
      phoneImageUrl,
      ...props
    },
    ref
  ) => {
    return (
      <section
        ref={ref}
        className={cn(APP_DOWNLOAD_BANNER_STYLES.root, className)}
        {...props}
      >
        <div className={APP_DOWNLOAD_BANNER_STYLES.card}>
          <p className={APP_DOWNLOAD_BANNER_STYLES.description}>
            {description}
          </p>

          <div className={APP_DOWNLOAD_BANNER_STYLES.badges}>
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="App Store"
            >
              <img
                src={appStoreImageUrl}
                alt="App Store"
                className={APP_DOWNLOAD_BANNER_STYLES.badge}
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href={playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Google Play"
            >
              <img
                src={playStoreImageUrl}
                alt="Google Play"
                className={APP_DOWNLOAD_BANNER_STYLES.badge}
                loading="lazy"
                decoding="async"
              />
            </a>
          </div>

          {phoneImageUrl && (
            <img
              src={phoneImageUrl}
              alt="App preview"
              className={APP_DOWNLOAD_BANNER_STYLES.phoneImage}
              loading="lazy"
              decoding="async"
            />
          )}
        </div>
      </section>
    );
  }
);

AppDownloadBanner.displayName = "AppDownloadBanner";
